export default __webpack_public_path__ + "static/media/spin-outer.48d87896.png";